import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Dialog,
  RadioGroup,
  Radio,
  FormControlLabel,
  Autocomplete,
  Chip,
  FormLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import useSnackbar from "../../hooks/useSnackbar.js";
import { createUser } from "../../api/user.js";
import useErrorHandler from "../../hooks/useErrorHandler.js";
import CaseTypeSelector from "../../components/CaseTypeSelector.jsx";
import useCaseTypesList from "../../hooks/useCaseTypesList.js";
import { createCaseQuesion } from "../../api/caseQuestions.js";

const emptyQuestionData = {
  question: "",
  multiple: false,
  case_type: "",
  order: 1,
  options: ["Yes", "No"],
};

export default function NewQuestion() {
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();
  const navigate = useNavigate();

  const { data: user } = useSelector((state) => state.user);

  const [questionData, setQuestionData] = useState(emptyQuestionData);

  const onInputChange = ({ target }) => {
    if (target.name === "multiple" && target.value === "false") {
      setQuestionData((prev) => ({
        ...prev,
        [target.name]: target.value,
        options: ["Yes", "No"],
      }));
    } else {
      setQuestionData((prev) => ({ ...prev, [target.name]: target.value }));
    }
  };

  const onCreateFormSubmit = async (e) => {
    e.preventDefault();
    console.log("ssss", caseType);
    try {
      await createCaseQuesion(user.token, {
        ...questionData,
        case_type: caseType.title,
        multiple: /true/.test(questionData.multiple),
      });
      snackbar.showSuccess();
      setQuestionData(emptyQuestionData);
      navigate("/questions");
    } catch (err) {
      console.log(err);
      handleError(err);
    }
  };

  const [caseType, setCaseType] = useState(null);
  const { caseTypeList } = useCaseTypesList();
  const [list, setList] = useState([]);
  useEffect(() => {
    setList(caseTypeList.map((t) => ({ title: t })));
  }, [caseTypeList]);

  return (
    <>
      {/* <Box mb={2} display="flex" justifyContent="flex-end">
        <Link to="/questions">
          <Button variant="contained" size="small" color="secondary">
            Cancel
          </Button>
        </Link>
      </Box> */}
      <Paper
        className="odr-card"
        component="form"
        onSubmit={onCreateFormSubmit}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Typography className="heading-title">Create Question</Typography>
        </Box>
        <Box px={2} pb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
              <FormControl>
                <FormLabel>Multiple Choice</FormLabel>
                <RadioGroup
                  row
                  value={questionData.multiple}
                  onChange={({ target }) =>
                    onInputChange({
                      target: { name: "multiple", value: target.value },
                    })
                  }
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={8} lg={8}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Question"
                name="question"
                value={questionData.question}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <CaseTypeSelector
                list={list}
                value={caseType}
                setValue={setCaseType}
              />
            </Grid>
            <Grid item xs={12} md={8} lg={8}>
              <OptionsSelector
                onChange={onInputChange}
                value={questionData.options}
                options={["Yes", "No"]}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                size="small"
                fullWidth
                onChange={onInputChange}
                required
                label="Order"
                name="order"
                value={questionData.order}
                type="number"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box display="flex" columnGap={1} justifyContent="flex-end">
                <Link to="/questions">
                  <Button
                    variant="outlined"
                    size="large"
                    className="black-border-button"
                  >
                    Cancel
                  </Button>
                </Link>

                <Button
                  size="large"
                  variant="contained"
                  type="submit"
                  className="blue-button"
                  disabled={/^trial_user$/i.test(user.roles) ? true : false}
                >
                  Create
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
}

function OptionsSelector({ onChange, value, options = [] }) {
  console.log(value);
  const snackbar = useSnackbar();
  const handleOnChange = (e, newValue) => {
    // Ensure that at least one option is selected
    if (newValue.length === 0) {
      snackbar.showError("Options should not be blank.");

      // Trigger an error or show a warning message
      return;
    }

    // Perform any other validation checks here

    // Call the onChange function with the updated value
    onChange({ target: { name: "options", value: newValue } });
  };
  return (
    <Autocomplete
      fullWidth
      size="small"
      multiple
      id="tags-filled"
      options={options}
      value={value}
      freeSolo
      onChange={handleOnChange}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            size="small"
            label={option}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          size="small"
          variant="outlined"
          label="Options"
          placeholder="Options"
        />
      )}
    />
  );
}
